import { createContext } from 'react';
import { UiLogicModules } from '../../../../infrastructure/types/models/UiLogicModules';
import { dummyValue } from '../../../../../shared/infrastructure/utils/contextUtils';

const UILogicContext = createContext<UiLogicModules>(dummyValue());

export { UILogicContext };
